import { configureStore } from '@reduxjs/toolkit';
import { favoritesAssignWidgetReducer } from '@cian/favorites-assign-widget';

import {
  recommendationsReducer,
  showHeaderReducer,
  landingTypeReducer,
  regionIdReducer,
  authenticationReducer,
  puidsReducer,
  experimentsReducer,
  isRedesignedMainPageReducer,
  newbuildingRecommendationsReducer,
  showFullListReducer,
  liquiditySourceReducer,
} from '../../slices';
import type { IApplicationContext } from '../../types';
import { newbuildingBannersReducer } from '../../slices/newbuildingBanners/newbuildingBannersSlice';
import { pikPromoBannerReducer } from '../../slices/pikPromoBanner';

export function createReduxStore(context: IApplicationContext, preloadedState: object, debug: boolean) {
  return configureStore({
    reducer: {
      recommendations: recommendationsReducer,
      showFullList: showFullListReducer,
      showHeader: showHeaderReducer,
      landingType: landingTypeReducer,
      regionId: regionIdReducer,
      authentication: authenticationReducer,
      favoritesAssignWidget: favoritesAssignWidgetReducer,
      puids: puidsReducer,
      experiments: experimentsReducer,
      isRedesignedMainPage: isRedesignedMainPageReducer,
      pikPromoBanner: pikPromoBannerReducer,
      newbuildingRecommendations: newbuildingRecommendationsReducer,
      newbuildingBanners: newbuildingBannersReducer,
      liquiditySource: liquiditySourceReducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: { extraArgument: context },
      }),
    devTools: debug,
    preloadedState,
  });
}
